import htmx from "htmx.org";

let initialized = false;
htmx.config.mode = "same-origin";
htmx.config.includeIndicatorCSS = false;

export function initializeHtmxIntegration(root: Document = document) {
  if (initialized) return;
  initialized = true;

  root.addEventListener("htmx:response:error", event => {
    const { ctx } = event.detail;
    const status = ctx.response?.status;
    if (status === 422) return;

    const source = ctx.sourceElement;
    const form = source instanceof HTMLFormElement
      ? source
      : source?.closest<HTMLFormElement>("form");
    const error = form?.querySelector<HTMLElement>("[data-htmx-error]");
    if (!error) return;

    error.textContent = status === 401
      ? "Your session has expired. Sign in again, then retry."
      : status === 403
        ? "You no longer have permission to do this."
        : "The request failed. Retry in a moment.";
    error.hidden = false;
  });
}
